module.exports = __webpack_public_path__ + "static/media/designPatent_30-1001968.46d1b81f.png";